//#region ImportsSection
import { t } from "i18next";
import React, { useState } from "react";
import Draggable from "react-draggable";
import {
  Button,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import swal from "sweetalert";
import { LoadingSpinner } from "../../../constants/const";
import { GetLanguageString } from "../../helper/Components";
import { GetSelectedLanguage } from "../../helper/Method";
import ApiGeneralConfig from "./ApiGeneralConfig";
//#endregion ImportsSection
const AddGeneralConfig = ({ setAddModal, refresh, setRefresh }) => {
  //#region StateSection
  const [values, setValues] = useState({
    key: "",
    value: "",
  });
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  //#endregion StateSection

  //#region functionSection
  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };

  const validate = () => {
    let temp = {};
    temp.key = values?.key ? (
      ""
    ) : (
      <GetLanguageString props="common_field_required_error" />
    );

    temp.value = values?.value ? (
      ""
    ) : (
      <GetLanguageString props="common_field_required_error" />
    );

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
      setButtonDisable(true);
      ApiGeneralConfig()
        .Add(values)
        .then((res) => {
          swal({
            title: t("general_config_added"),
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            icon: "success",
            buttons: GetSelectedLanguage() === "en" ? "OK" : "ٹھیک ہے ",
          });
          setRefresh(!refresh);
          setAddModal(false);
          setLoading(false);
          setButtonDisable(false);
        })
        .catch((err) => {
          swal({
            title: err,
            icon: "error",
            buttons: "OK",
          });
          setLoading(false);
          setButtonDisable(false);
        });
    }
  };
  //#endregion functionSection

  return (
    <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
      <Modal isOpen={true} className="inmodal" autoFocus={false}>
        <ModalHeader className="modal-title" tag="h4">
          <GetLanguageString props="general_config_add" />
        </ModalHeader>
        {!loading ? (
          <Form onSubmit={handleSubmit}>
            <ModalBody>
              <FormGroup>
                <Label>
                  <GetLanguageString props="general_config_key" />
                </Label>
                <Input
                  autoFocus
                  type="text"
                  name="key"
                  value={values.key}
                  onChange={handleInputChange}
                  {...(errors?.key && { invalid: true })}
                />
                {errors?.key && (
                  <FormFeedback>
                    <h4>{errors?.key}</h4>
                  </FormFeedback>
                )}
              </FormGroup>
              <FormGroup>
                <Label>
                  <GetLanguageString props="general_config_value" />
                </Label>
                <Input
                  type="text"
                  name="value"
                  value={values.value}
                  onChange={handleInputChange}
                  {...(errors?.value && { invalid: true })}
                />
                {errors?.value && (
                  <FormFeedback>
                    <h4>{errors?.value}</h4>
                  </FormFeedback>
                )}
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="white" onClick={() => setAddModal(false)}>
                <GetLanguageString props="common_cancel" />
              </Button>
              <Button color="primary" type="submit" disabled={buttonDisable}>
                <GetLanguageString props="common_save" />
              </Button>{" "}
            </ModalFooter>
          </Form>
        ) : (
          LoadingSpinner()
        )}
      </Modal>
    </Draggable>
  );
};

export default AddGeneralConfig;
